import type { ElementType, ReactNode } from 'react'
import Container from '@/components/primitives/Container'
import Section from '@/components/primitives/Section'

type SectionContainerProps<T extends ElementType> = {
  as?: T
  id?: string
  size?: 'page' | 'container' | 'content'
  className?: string
  innerClassName?: string
  children: ReactNode
}

function SectionContainer<T extends ElementType = 'section'>(
  { as, id, size = 'container', className, innerClassName, children }: SectionContainerProps<T>
) {
  return (
    <Section as={as} id={id} className={className}>
      <Container size={size} className={innerClassName}>
        {children}
      </Container>
    </Section>
  )
}

export default SectionContainer
